/* hh-megamenu.js — 260711
   Desktop (>=992px): open the mega menu on HOVER instead of requiring a click.
   Click still works (the theme's dropdown-component owns the state — we just drive it),
   and keyboard/focus behaviour is untouched.

   260824 — HOVER CORRIDOR.
   The panel is a DOM child of the <li>, but it is NOT positioned against it: the whole
   nav chain is position:static, so the panel's `top:100%` resolves against <header>, and
   it lands ~24 px below the nav item (header padding). That strip belongs to the header,
   so moving the pointer down into the panel DOES fire mouseleave on the <li>, and the old
   flat close timer then expired mid-strip — measured: the menu closed at every realistic
   pointer speed, before the pointer could reach the panel and re-enter the <li>.
   Fixed by treating that strip as part of the menu (a "safe corridor") rather than by a
   longer timer, so nothing invisible is laid over the header and no click is swallowed. */
(function () {
  var OPEN_DELAY = 60;    /* small, so it feels instant but ignores a pointer just passing through */
  var CLOSE_DELAY = 180;  /* pointer left sideways or upwards — unchanged */
  var CORRIDOR_PAD = 150; /* horizontal slack in the strip, for a diagonal move into the panel */

  function isDesktop() {
    return window.matchMedia('(min-width: 992px)').matches;
  }

  function bind(li) {
    if (li.__hhHoverBound) return;
    var opener = li.querySelector('.main-navigation_dropdown-opener');
    if (!opener) return;
    li.__hhHoverBound = true;

    var panel = li.querySelector('.--mega-dropdown-wrapper');
    var timer;
    var watching = false;

    function isOpen() {
      return opener.getAttribute('aria-expanded') === 'true';
    }

    function close() {
      stopWatch();
      if (isOpen()) opener.click();
    }

    /* "still in the menu" = inside the <li>, inside the open panel, or in the strip
       between the two. The strip is kept narrow horizontally so that sliding sideways
       along the header still closes the menu. */
    function inMenu(x, y) {
      var l = li.getBoundingClientRect();
      if (x >= l.left && x <= l.right && y >= l.top && y <= l.bottom) return true;
      if (!panel) return false;
      var p = panel.getBoundingClientRect();
      if (!p.height) return false;
      if (x >= p.left && x <= p.right && y >= p.top && y <= p.bottom) return true;
      return y >= l.bottom && y <= p.top &&
        x >= l.left - CORRIDOR_PAD && x <= l.right + CORRIDOR_PAD;
    }

    function onMove(e) {
      if (inMenu(e.clientX, e.clientY)) return;
      stopWatch();
      clearTimeout(timer);
      timer = setTimeout(close, CLOSE_DELAY);
    }

    /* pointer left the window entirely — no further mousemove will ever arrive */
    function onWindowOut(e) {
      if (e.relatedTarget || e.toElement) return;
      close();
    }

    function startWatch() {
      if (watching) return;
      watching = true;
      document.addEventListener('mousemove', onMove, true);
      document.addEventListener('mouseout', onWindowOut, true);
    }

    function stopWatch() {
      if (!watching) return;
      watching = false;
      document.removeEventListener('mousemove', onMove, true);
      document.removeEventListener('mouseout', onWindowOut, true);
    }

    li.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      stopWatch();
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!isOpen()) opener.click();
      }, OPEN_DELAY);
    });

    li.addEventListener('mouseleave', function (e) {
      if (!isDesktop()) return;
      clearTimeout(timer);
      if (isOpen() && inMenu(e.clientX, e.clientY)) {
        /* on the way down into the panel — let the pointer decide, not a stopwatch */
        startWatch();
        return;
      }
      timer = setTimeout(close, CLOSE_DELAY);
    });
  }

  function init() {
    document
      .querySelectorAll('.main-navigation--desktop .main-navigation_item.--mega-menu-active')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
